import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const FleetManagementPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  fleetManagerContact,
  maintenanceProviderContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Fleet_Management_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Fleet Management Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        The purpose of this Fleet Management Policy is to ensure the safe, efficient, and cost-effective operation of the company's vehicle fleet while maintaining compliance with all legal and regulatory requirements.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all vehicles owned, leased, or operated by {clientName || "the Company"}, including cars, HGVs, PSVs, and specialist vehicles.
      </p>

      <h4 className="section-title">3. Fleet Acquisition and Disposal</h4>
      <ul>
        <li>Vehicles will be selected based on operational needs, fuel efficiency, safety features, and environmental impact.</li>
        <li>All acquisitions will be authorised by the Fleet Manager in consultation with senior management.</li>
        <li>End-of-life vehicles will be disposed of responsibly, considering environmental impact and data security (e.g., removal of GPS tracking data).</li>
      </ul>

      <h4 className="section-title">4. Maintenance and Roadworthiness</h4>
      <ul>
        <li>Regular maintenance schedules will be strictly adhered to, including inspections, servicing, and repairs.</li>
        <li>All vehicles must comply with relevant roadworthiness standards and legislation, including MOT and annual tests.</li>
        <li>Drivers are required to perform daily walkaround checks and report any defects immediately.</li>
      </ul>

      <h4 className="section-title">5. Driver Responsibilities</h4>
      <ul>
        <li>Drivers must hold the correct licences and valid CPC qualifications where applicable.</li>
        <li>They must adhere to all company driving policies, including speed limits, safe driving practices, and reporting incidents.</li>
        <li>Use of company vehicles for personal use is subject to authorisation and company policy.</li>
      </ul>

      <h4 className="section-title">6. Compliance and Record Keeping</h4>
      <ul>
        <li>Fleet records including vehicle documents, maintenance logs, and driver records will be maintained accurately and securely.</li>
        <li>The Fleet Manager will ensure compliance with Transport Manager duties and liaise with regulatory bodies as required.</li>
      </ul>

      <h4 className="section-title">7. Health, Safety and Environmental Considerations</h4>
      <ul>
        <li>Safety of drivers, passengers, and the public is paramount.</li>
        <li>Vehicles will be selected and maintained to minimise environmental impact, including consideration of alternative fuels.</li>
        <li>Emergency equipment and procedures must be in place in all vehicles.</li>
      </ul>

      <h4 className="section-title">8. Training and Development</h4>
      <p className="section-content">
        Regular training will be provided to drivers and fleet personnel to promote safe, efficient, and compliant fleet operations.
      </p>

      <h4 className="section-title">9. Monitoring and Continuous Improvement</h4>
      <p className="section-content">
        Fleet performance will be monitored through telematics, driver feedback, and regular audits to identify opportunities for improvement.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Fleet Manager:</strong> {fleetManagerContact || "[Insert Contact Number]"}</li>
        <li><strong>Maintenance Provider:</strong> {maintenanceProviderContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Fleet Management Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default FleetManagementPolicy;
